import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Bell, Inbox, ListChecks } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function NotificationsBell() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const load = async () => { try { const { data } = await api.get("/notifications"); setItems(data); } catch {} };
  useEffect(() => { load(); const id = setInterval(load, 30000); return () => clearInterval(id); }, []);
  const count = items.length;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" data-testid="notifications-btn">
          <Bell className="w-5 h-5" />
          {count > 0 && <span className="absolute top-1 right-1 w-4 h-4 rounded-full bg-red-500 text-white text-[9px] flex items-center justify-center font-semibold">{count > 9 ? "9+" : count}</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 max-h-96 overflow-y-auto">
        <DropdownMenuLabel className="flex items-center justify-between">
          <span>Notifiche</span>
          {count > 0 && <Badge variant="outline" className="text-[10px]">{count}</Badge>}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {count === 0 && <div className="text-xs text-slate-400 text-center py-6">Tutto in ordine ✓</div>}
        {items.map(n => (
          <DropdownMenuItem key={n.id} onClick={() => navigate(n.link)} className="flex items-start gap-2 cursor-pointer">
            {n.kind === "memo" ? <Inbox className="w-4 h-4 text-amber-600 mt-0.5" /> : <ListChecks className="w-4 h-4 text-red-600 mt-0.5" />}
            <div className="flex-1 min-w-0">
              <div className="text-xs font-medium text-navy-900 truncate">{n.title}</div>
              <div className="text-[11px] text-slate-500 truncate">{n.subtitle}</div>
            </div>
            {n.priority === "urgente" && <Badge className="bg-red-100 text-red-700 border-0 text-[9px]">!</Badge>}
            {n.priority === "alta" && <Badge className="bg-orange-100 text-orange-700 border-0 text-[9px]">A</Badge>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
